import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.path
      ? { '@id': `https://mkgcgcb.cn${item.path}`, name: item.name }
      : { name: item.name },
  }));

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="pt-24 pb-4">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <ol className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
            {items.map((item, index) => (
              <li key={index} className="flex items-center gap-1.5">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
                )}
                {item.path && index < items.length - 1 ? (
                  <Link
                    to={item.path}
                    className="hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {item.name}
                  </Link>
                ) : (
                  <span className={index === items.length - 1 ? 'text-primary-500 font-medium' : ''}>
                    {item.name}
                  </span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
}